import React from 'react';
import { CheckSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function OnboardingTasksWidget() {
  const navigate = useNavigate();
  const tasks = [{
    id: 1,
    title: "Compléter le formulaire d'accueil",
    status: 'completed'
  }, {
    id: 2,
    title: 'Configurer le poste de travail',
    status: 'completed'
  }, {
    id: 3,
    title: "Rencontrer l'équipe",
    status: 'in-progress'
  }, {
    id: 4,
    title: 'Formation initiale',
    status: 'pending'
  }, {
    id: 5,
    title: 'Définir les objectifs',
    status: 'pending'
  }];
  const completedTasks = tasks.filter(task => task.status === 'completed').length;
  const totalTasks = tasks.length;
  const progressPercentage = Math.round(completedTasks / totalTasks * 100);
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-2025">
      <div className="flex items-center justify-between mb-4" data-id="element-2026">
        <h3 className="font-semibold text-gray-900" data-id="element-2027">Onboarding</h3>
        <CheckSquare className="h-5 w-5 text-blue-600" data-id="element-2028" />
      </div>
      <div className="mb-4" data-id="element-2029">
        <div className="flex justify-between mb-1" data-id="element-2030">
          <span className="text-sm text-gray-600" data-id="element-2031">Progression</span>
          <span className="text-sm font-medium text-gray-700" data-id="element-2032">
            {progressPercentage}%
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2033">
          <div className="bg-blue-600 h-2.5 rounded-full" style={{
          width: `${progressPercentage}%`
        }} data-id="element-2034"></div>
        </div>
      </div>
      <div className="space-y-2 max-h-48 overflow-y-auto flex-1" data-id="element-2035">
        {tasks.map(task => <div key={task.id} className="flex items-center" data-id="element-2036">
            <div className={`flex-shrink-0 h-5 w-5 rounded-full border ${task.status === 'completed' ? 'bg-green-500 border-green-500' : task.status === 'in-progress' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center mr-3`} data-id="element-2037">
              {task.status === 'completed' && <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-2038">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-2039" />
                </svg>}
            </div>
            <span className={`text-sm ${task.status === 'completed' ? 'text-gray-500 line-through' : 'text-gray-700'}`} data-id="element-2040">
              {task.title}
            </span>
          </div>)}
      </div>
      <button onClick={() => navigate('/onboarding')} className="mt-4 w-full py-2 px-4 border border-gray-300 hover:bg-gray-50 rounded-md text-sm font-medium text-gray-700 transition-colors duration-150 ease-in-out" data-id="element-2041">
        Voir toutes les tâches
      </button>
    </div>;
}